<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
        <div class="datebox" style="width: 10%">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.pStartDate"
          />
        </div>
        <div class="datebox" style="width: 10%">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate"
          />
        </div>
        <div class="datebox" style="width: 10%">
          <select
            @change="refresh"
            v-model="selected_website"
            class="form-control text-uppercase"
          >
            <option value="https://www.amazon.in">Amazon</option>
            <!-- <option value="https://www.flipkart.com">Flipkart</option> -->
          </select>
        </div>
        <div class="datebox" style="width: 13%">
          <select
            @change="icChanged"
            v-model="selectedItemCategory"
            class="form-control text-uppercase"
          >
            <option v-for="d in itemCategory" :value="d" :key="d.key">
              {{ d.value }}
            </option>
          </select>
        </div>
        <div class="datebox" style="width: 13%">
          <select
            @change="icChanged"
            v-model="dataType"
            class="form-control text-uppercase"
          >
            <option value="category">Category</option>
            <option value="search">Search</option>
          </select>
        </div>
        <div class="datebox" style="width: 10%">
          <button @click="icChanged" class="btn btn-block weavrpurple" type="button">
            <span style="font-size: 13px">Submit</span>
          </button>
        </div>
        <div class="datebox" style="width: 10%">
          <button @click="exportNow" class="weavrpurple">Export</button>
        </div>
      </div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float: right">
          <button
            @click="backToSov"
            style="width: max-content; float: right"
            class="btn btn-block weavrpurple"
            type="button"
          >
            <i class="fa fa-arrow-left"></i>
            <span style="font-size: 13px"> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend">
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9 !important"></i>
              <span>Mothercare</span>
            </div>
          </div>
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr
                v-for="(r, i) in rows_details"
                :key="i"
                :class="{ markitamd: r['brand'] == client }"
              >
                <td v-for="d in columns_details" :key="d.field">
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{ r[d.field] }}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{ r[d.field] }}</span>
                    </span>
                    <span v-else>-</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal size="lg" title="Audit" v-model="showAuditModal">
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'compliance_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'position_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'sku_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(Compliance Score + Position Score + Rating Score)/3"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'rating_score'">
                <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ r[d.field] }}
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'category_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'logo'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'image_count'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'nomenclature'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'message'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging"
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "sovdetail",
  components: { Datepicker },
  watch: {
    selected_website: function () {
      let self = this;
      if (self.selected_website == "https://www.flipkart.com") {
        self.itemCategory = [
          { key: "tshirts", value: "T Shirts" },
          { key: "dresses", value: "Dresses" },
          { key: "jeans", value: "Jeans" },
        ];
      } else {
        self.itemCategory = [
          { key: "tshirts", value: "T Shirts" },
          { key: "dresses", value: "Dresses" },
          { key: "jeans", value: "Jeans" },
        ];
      }
      localStorage.demo_selected_website = this.selected_website;
    },
  },
  data: function () {
    return {
      selected_website: "https://www.amazon.in",
      date: {
        pStartDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        disabled: {
          pstart: {
            to: "",
            from: moment("2022-03-01").toDate(),
          },
          start: {
            to: moment("2022-02-21").toDate(),
            from: moment("2022-03-01").toDate(),
          },
        },
      },
      columns_details: [
        { label: "Rank", field: "order" },
        { label: "Page", field: "page" },
        { label: "Brand", field: "brand" },
        { label: "Name", field: "product_name", sortable: false },
        { label: "Original Price", field: "original_price", sortable: false },
        { label: "Discounted Price", field: "discount_price", sortable: false },
        { label: "Discount", field: "discount", sortable: false },
        { label: "Reviews", field: "reviews" },
        { label: "Ratings", field: "ratings" },
      ],
      rows: [],
      rows_details: [],
      page: 1,
      showAuditModal: false,
      columnsAudit: [
        { label: "SKU", field: "sku", sortable: false },
        { label: "Compliance Score", field: "compliance_score", sortable: false },
        { label: "Position Score", field: "position_score", sortable: false },
        { label: "Rating Score", field: "rating_score", sortable: false },
        { label: "SKU Score", field: "sku_score", sortable: false },
      ],
      columns_category: [
        { label: "Category Position", field: "category_position", sortable: false },
        {
          label: "Category page position (1-3)",
          field: "category_13_position",
          sortable: false,
        },
        { label: "Search Position", field: "search_position", sortable: false },
        { label: "Search (1-3) Position", field: "search_13_position", sortable: false },
      ],
      columns_compliance: [
        { label: "Product Logo", field: "logo", sortable: false },
        { label: "OEM Images", field: "image_count", sortable: false },
        { label: "Nomenclature", field: "nomenclature", sortable: false },
        { label: "Message", field: "message", sortable: false },
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      itemCategory: [],
      selectedItemCategory: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      dataType: "category",
      icChangeOccur: false,
    };
  },
  mounted() {
    let self = this;
    // if(localStorage.philips_startDate) this.date.startDate = localStorage.philips_startDate
    // if(localStorage.philips_prevStartDate)  this.date.pStartDate = localStorage.philips_prevStartDate
    if (localStorage.demo_selected_website)
      this.selected_website = localStorage.demo_selected_website;

    if (self.selected_website == "https://www.flipkart.com") {
      self.itemCategory = [
        { key: "tshirts", value: "T Shirts" },
        { key: "dresses", value: "Dresses" },
        { key: "jeans", value: "Jeans" },
      ];
    } else {
      self.itemCategory = [
        { key: "tshirts", value: "T Shirts" },
        { key: "dresses", value: "Dresses" },
        { key: "jeans", value: "Jeans" },
      ];
    }
    if (localStorage.demo_selectedItemCategory) {
      this.selectedItemCategory = {};
      for (let [i, k] of this.itemCategory.entries()) {
        if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
          this.selectedItemCategory = k;
        }
      }
      if (!Object.keys(this.selectedItemCategory).length) {
        this.selectedItemCategory = this.itemCategory[0];
      }
    } else self.selectedItemCategory = this.itemCategory[0];
    this.initCols();
  },
  methods: {
    exportNow() {
      let self = this;
      self.loader = true;
      const url = "/api/india_clinets/sov_detail_download";
      let payload = {
        item_category: "tshirts",
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        website: "https://www.amazon.in",
        client: "mothercare",
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          window.location = response.body.data;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    initCols() {
      this.columns_details = [
        { label: "Rank", field: "order" },
        { label: "Page", field: "page" },
        { label: "Brand", field: "brand" },
        { label: "Name", field: "product_name", sortable: false },
        { label: "Original Price", field: "original_price", sortable: false },
        { label: "Discounted Price", field: "discounted_price", sortable: false },
        { label: "Discount", field: "discount", sortable: false },
        { label: "Reviews", field: "reviews" },
        { label: "Ratings", field: "ratings" },
      ];
      if (this.date.pStartDate != this.date.startDate) {
        this.columns_details.splice(0, 2);
      }
      this.website_details();
    },
    icChanged() {
      this.icChangeOccur = true;
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.refresh();
    },

    backToSov() {
      window.location = "#/sov-mothercare";
    },
    showHeroChange() {
      let self = this;
      $("#myTable2").DataTable().destroy();
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset);
          }
        } else this.rows_details.push(dataset);
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },

    openAuditModal(r) {
      let self = this;
      self.rowsAudit = [];
      self.showAuditModal = true;
      self.rowsAudit.push(r.audit);
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      let self = this;
      $("#myTable2").DataTable().destroy();
      if (!self.icChangeOccur) {
        this.selectedItemCategory = { key: "tshirts", value: "T Shirts" };
        localStorage.demo_selectedItemCategory = JSON.stringify(
          this.selectedItemCategory
        );
      }
      self.icChangeOccur = false;
      this.initCols();
    },

    website_details() {
      let self = this;
      self.loader = true;
      this.rows_details = [];
      this.rows_details_full = [];
      const url = "/api/india_clients/product_website_details";
      let payload = {
        item_category: self.selectedItemCategory.key,
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        website: self.selected_website,
        client: "mothercare",
        data_type: self.dataType,
      };
      this.$http.post(url, payload).then(
        (response) => {
          let resData = response.body.data.data;
          for (let [idx, ds] of resData.entries()) {
            self.rows_details.push(ds);
            self.rows_details_full.push(ds);
          }
          self.loader = false;
          self.$nextTick(function () {
            self.initDt2();
          });
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    changeCustomDate() {
      if (this.date.pStartDate)
        this.date.pStartDate = moment(this.date.pStartDate).format("YYYY-MM-DD");
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      localStorage.philips_startDate = this.date.startDate;
      localStorage.philips_prevStartDate = this.date.pStartDate;
    },
    initDt2() {
      let self = this;
      $("#myTable2").DataTable({
        initComplete: function () {
          this.api()
            .columns()
            .every(function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());
                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });
              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  var myVal = $(d).text();
                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                  numeric: true,
                  ignorePunctuation: true,
                })
              );
              for (let [idx, ds] of sortedArr.entries()) {
                select.append("<option value='" + ds + "'>" + ds + "</option>");
              }
            });
        },
      });
    },
  },
};
</script>

<style scoped>
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}
.markitintel {
  background-color: #c7e0ff !important;
}
.markitsnap {
  background-color: #ffd0f5 !important;
}
.markitna {
  background-color: #edf2fb !important;
}
.markittek {
  background-color: #fff0ce !important;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
  margin-bottom: 0;
  line-height: 31px;
}
.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}
.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}
.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}
.amd-legend i {
  width: fit-content;
}
.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}
.legending {
  display: inline-block;
  margin-right: 19px;
}
#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}
.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
</style>
